<div id="wrapper">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Unauthorized.</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <button matSuffix mat-icon-button aria-label="Logout" type="submit">
        <mat-icon>logout</mat-icon>
      </button>
    </mat-card-content>
  </mat-card>
</div>
